// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function page_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var page_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "page_name"), null));
  if (page_name.TAG === /* Ok */0) {
    var version_access = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "version_access"), null));
    if (version_access.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                page_name: page_name._0,
                version_access: version_access._0
              }
            };
    }
    var e = version_access._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".version_access" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = page_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".page_name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function admin_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      var email = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
      if (email.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  id: id._0,
                  name: name._0,
                  email: email._0
                }
              };
      }
      var e = email._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".email" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var admin = admin_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "admin"), null));
  if (admin.TAG === /* Ok */0) {
    var page_config = Decco.listFromJson(page_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "page_config"), null));
    if (page_config.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                admin: admin._0,
                page_config: page_config._0
              }
            };
    }
    var e = page_config._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".page_config" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = admin._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".admin" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  page_decode ,
  admin_decode ,
  t_decode ,
  
}
/* No side effect */
